import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store/"
import "./plugins"
import "./filters"
import i18n from "./i18n"
// import "./registerServiceWorker"
// import VueAnalytics from "vue-analytics"
import VueGtag from "vue-gtag"
import { VueReCaptcha } from "vue-recaptcha-v3"

import "@fortawesome/fontawesome-free/css/all.css"
import "./assets/scss/main.scss"

// Vue.use(VueAnalytics, {
//   id: "UA-16332291-32",
//   router,
//   ignoreRoutes: ["contest-closed", "error"],
//   autoTracking: {
//     transformQueryString: false,
//     skipSamePath: true
//   },
//   debug: {
//     sendHitTask: process.env.NODE_ENV === "production"
//   }
// })

Vue.use(
  VueGtag,
  {
    config: {
      pageTrackerExcludedRoutes: ["contest-closed", "error"],
      id: "GTM-NRHJZPD"
      // params: {
      //   send_page_view: false
      // }
    }
  },
  router
)

Vue.use(VueReCaptcha, { siteKey: "6LfK7cYeAAAAAK979fglKbot1AmXiRwqKqtHlFhv" })

Vue.config.productionTip = false

store.dispatch("app/checkIsContestClosed")
const domain = window.location.hostname
store.commit("app/setAppDomain", domain)
if (!store.state.app.isContestClosed) {
  store.dispatch("app/loadDestinations")
}
store.dispatch("app/updateUTMs")

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app")
